const observationBehaviorIds = {
    CanReview: 'CanReview',
    CanLinkToFrameworks: 'CanLinkToFrameworks',
    CanSendObservation: 'CanSendObservation',
    CanAddNextSteps: 'CanAddNextSteps',
    CanRequestReview: 'CanRequestReview',
    CanEditObservation: 'CanEditObservation',
    CanDeleteObservation: 'CanDeleteObservation',
    CanStealObservation: 'CanStealObservation',
    CanAddStatementRefinements: 'CanAddStatementRefinements',
    CanAddObservation: 'CanAddObservation',
    CanAddAssessment: 'CanAddAssessment',
    CanAddTwoYearProgress: 'CanAddTwoYearProgress',
    CanAddRefinements: 'CanAddRefinements', // Deprecated
    CanAddAreaRefinements: 'CanAddAreaRefinements',
    CanAddMultipleChildren: 'CanAddMultipleChildren',
    CanAddUpToSpeedObservation: 'CanAddUpToSpeedObservation',
    CanViewTwoYearProgress: 'CanViewTwoYearProgress',
    CanPrintLearningJourney: 'CanPrintLearningJourney',
    CanAddParentObservation: 'CanAddParentObservation',
    ObservationVariantAmbiguity: 'ObservationVariantAmbiguity',
    CanAddAssessmentAreaRefinementNotes: 'CanAddAssessmentAreaRefinementNotes',
    UseObservationVersion: 'UseObservationVersion',
    CanOptOutOfNavigationV2: 'CanOptOutOfNavigationV2',
};

export default observationBehaviorIds;
